import React, { useState, useEffect } from 'react'
import { Modal, message, Button, Spin } from 'antd'
import moment from 'moment'
import styles from './index.less'
import QRCode from 'qrcode.react'
import copy from 'copy-to-clipboard'
import html2img from '@/utils/html2img'
import { queryCodeToken } from './fetchs'
import { USER_ID, CLINIC_KEY } from "@/utils/consts"

const URLS = {
  dev: 'http://offisite.develop.ancare.net',
  test: 'http://offisite.develop.ancare.net',
  production: 'https://www.ancare.net'
}

export default function EditCustomerCodeDialog(props) {
  const { closeModal, visible, customerId } = props
  const environment = process.env.ENV
  // const createdBy = localStorage.getItem(USER_ID)
  const clinicId = localStorage.getItem(CLINIC_KEY)
  const [codeUrl, setCodeUrl] = useState('')
  const [isErr, setIsErr] = useState(false)

  useEffect(() => {
    if (customerId) {
      queryCodeToken(customerId)
        .then(({ data, code }) => {
          if (code == 0 && data) {
            setCodeUrl(`${URLS[environment]}/editByCustomer?token=${data}&clinicId=${clinicId}&customerId=${customerId}`)
          } else {
            setIsErr(true)
          }
        })
      // const result = await queryCodeToken(customerId)
      // console.log(result)
    }
  }, [])

  // 复制邀请链接
  const handleCopy = () => {
    copy(codeUrl)
    return message.success('个人登记表链接已复制')
  }

  const downloadCode = () => {
    const printContent = document.getElementById("qrcode").parentNode
    if (printContent) {
      html2img(printContent)
    }
  }

  return (
    <Modal
      title='个人登记表链接二维码'
      footer={null}
      visible={visible}
      onCancel={closeModal}
    >
      <Spin spinning={isErr} tip="生成链接失败,请联系开发人员">
        <div className='clearfix'>
          <div style={{ float: 'left', height: 200 }}>
            <QRCode
              id='qrcode'
              value={codeUrl}
              size={200}
            />
          </div>
          <div style={{ float: 'left', padding: 20, width: 150, height: 200 }}>
            <Button onClick={handleCopy}>生成并复制链接形式</Button>
            <Button style={{ marginTop: 20 }} onClick={downloadCode}>生成并下载二维码形式</Button>
          </div>
        </div>
      </Spin>
    </Modal>
  )
} 